export const dateWithoutTimezone = (date: Date) => {
  const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const withoutTimezone = new Date(date.valueOf() - tzoffset).toISOString().slice(0, -1);
  return withoutTimezone;
};

export const extractDateFromCNP = (cnp: string) => {
  const centuryMap = { '1': '19', '2': '19', '3': '18', '4': '18' };
  const century = centuryMap[cnp[0]] || '20';
  const year = `${century}${cnp.slice(1, 3)}`;
  const month = cnp.slice(3, 5);
  const day = cnp.slice(5, 7);
  return `${day}.${month}.${year}`;
};
